import { render, staticRenderFns } from "./s-feature.vue?vue&type=template&id=1431f2e5&scoped=true&"
import script from "./s-feature.vue?vue&type=script&lang=js&"
export * from "./s-feature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1431f2e5",
  null
  
)

export default component.exports